import { useQuery } from '@tanstack/react-query';
import { fetchAllMessages } from '../services/AdministrationService';

export const useMessagesByOwner = () => {
    const query = useQuery({
        queryKey: ['admin', 'messages', 'by-owner'],
        queryFn: async () => {
            const result = await fetchAllMessages({ limit: 1000 });
            
            const countsByOwner: Record<string, number> = {};
            result.items.forEach((message: any) => {
                const owner = message.createdByUsername || 'Unknown';
                countsByOwner[owner] = (countsByOwner[owner] || 0) + 1;
            });
            
            return Object.entries(countsByOwner).map(([name, value]) => ({
                name,
                value
            }));
        }
    });

    return {
        data: query.data || [],
        loading: query.isLoading
    };
};
